import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import AboutModal from '../common/AboutModal';

const Footer = () => {
  const location = useLocation();
  const [isOnboardingPage, setIsOnboardingPage] = useState(false);
  const [aboutModalOpen, setAboutModalOpen] = useState(false);

  useEffect(() => {
    setIsOnboardingPage(location.pathname.includes('/onboarding'));
  }, [location]);

  if (isOnboardingPage) {
    return null;
  }

  const openFeedbackModal = () => {
    const event = new Event('openFeedback');
    window.dispatchEvent(event);
  };

  const openAboutModal = () => {
    setAboutModalOpen(true);
  };

  const closeAboutModal = () => {
    setAboutModalOpen(false);
  };

  const openWaitlistModal = () => {
    const modal = document.getElementById('waitlist-modal');
    if (modal) {
      if (typeof modal.showModal === 'function') {
        modal.showModal();
      } else {
        alert('Your browser does not support the dialog element.');
      }
    } else {
      alert('Waitlist modal not found. Please try again on the home page.');
    }
  };

  return (
    <footer style={{ background: '#060e1a' }} className="border-t border-oliveGold/10 py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="md:flex md:items-center md:justify-between">
          <div className="flex flex-wrap justify-center md:justify-start space-x-4 md:space-x-6 items-center">
            <Link to="/" className="text-white/50 hover:text-oliveGold transition-colors">
              Home
            </Link>
            <button
              onClick={openAboutModal}
              className="text-white/50 hover:text-oliveGold transition-colors cursor-pointer"
            >
              About
            </button>
            <button
              onClick={openFeedbackModal}
              className="text-white/50 hover:text-oliveGold transition-colors cursor-pointer"
            >
              Feedback
            </button>
            <button
              onClick={openWaitlistModal}
              className="mt-2 md:mt-0 px-3 py-1 text-sm border border-oliveGold/30 text-oliveGold/70 rounded-md hover:bg-oliveGold/10 transition-colors"
            >
              Join the Waitlist
            </button>
          </div>
          <p className="mt-4 text-center md:mt-0 md:text-right text-sm text-white/30">
            &copy; {new Date().getFullYear()} Ancient Greece Revisited. All rights reserved.
          </p>
        </div>
        <div className="mt-4 text-center text-xs text-white/20">
          <p>Demo Version - For Presentation Only</p>
        </div>
      </div>

      {/* About Modal */}
      <AboutModal isOpen={aboutModalOpen} onClose={closeAboutModal} />
    </footer>
  );
};

export default Footer;
